import React from "react";
import clickWrap from "@js/helpers/click_wrap.js";
import LoadingSpinner from "@js/components/studio/utilities/loading_spinner.jsx";

const ModalFooter = (props) => {

  let actions = [];

  if ( !props.children ) {
    let cancelButton = !props.children && props.onCancel && (
      <button
        key="cancel"
        className="diminished-button button btn btn-close"
        onClick={clickWrap(props.onCancel)}
      >
        {props.cancelText || t("buttons.cancel")}
      </button>
    );

    let saveClasses = ["button", "btn", "btn-close"];
    if ( props.dangerous ) saveClasses.push("dangerous-button");

    let saveButton = !props.children && props.onSave && (
      <button
        key="save"
        className={saveClasses.join(" ")}
        onClick={clickWrap(props.onSave)}
      >
        {props.saveText || t("buttons.save")}
      </button>
    );

    if ( props.loading ) {
      const loading = <LoadingSpinner key="loading" width="18px" height="18px" />;
      actions.push(loading);
    } else {
      actions.push(cancelButton);
      actions.push(saveButton);
    }
  }

  return (
    <div className="modal-footer" style={{ height: "65px" }}>
      {
        props.children ? (
          props.children
        ) : (
          actions
        )
      }
    </div>
  );

};

export default ModalFooter;
